export const dictionary = {
	de: {
		management: 'Verwaltung',
		times: 'Zeitverwaltung',
	},
	en: {
		management: 'Management',
		times: 'Times',
	},
};
